"use client";

import { useTranslations } from "next-intl";
import { useState } from "react";
import { Button, buttonVariants } from "@/components/ui/button";
import { MultidietPickerPopup } from "@/features/multidiet-picker/components/multidiet-picker-popup";
import { cn } from "@/lib/utils";

type MultidietCtaButtonProps = {
  buttonLabel?: string | React.ReactNode;
  testId?: string;
  children?: React.ReactNode;
  className?: string;
};

export const MultidietCtaButton = ({
  buttonLabel,
  testId = "",
  children,
  className,
}: MultidietCtaButtonProps) => {
  const [open, setOpen] = useState(false);
  const t = useTranslations("staticBuilder.multidiet");

  return (
    <MultidietPickerPopup open={open} setOpen={setOpen}>
      {children || (
        <Button
          className={cn(
            buttonVariants({
              className: "min-h-0 px-3 py-2 md:px-6 md:py-3",
            }),
            className,
          )}
          data-pw={testId}
          onClick={() => setOpen(true)}
        >
          <span>{buttonLabel || t("cta")}</span>
        </Button>
      )}
    </MultidietPickerPopup>
  );
};
